<template>
  <section class="selected-category">
    <div class="selected-category__content">
      <h1>{{ getTranslations.home_selected_theme_round }} {{ currentRoundNumber }}</h1>
      <div class="selected-category__content__icon">
        <img :src="themeIconURL" alt="">
        <span class="selected-category__content__icon__name">{{ themeMultilanguageText }}</span>
      </div>
    </div>
  </section>
</template>

<script>
/* eslint no-console: "off" */
import { mapState, mapGetters, mapMutations } from 'vuex';
import webSocket from '@/common/webSocket';
import { ParseResponseMixin, GameMixin2, GameMixin3 } from '@/common/mixins/game';

export default {
  name: 'selected-theme',
  mixins: [ParseResponseMixin, GameMixin2, GameMixin3],
  data() {
    return {
      stompClient: null,
      subscription: null,
      themeIconURL: '',
      themeMultilanguageText: '',
    };
  },
  created() {
    console.log('in SelectedTheme created hook');
    this.stompClient = webSocket.getGameStompClient();
    console.log('this.stompClient:', this.stompClient);

    console.log('this.homePlayerCurrentSelectedTheme:', this.homePlayerCurrentSelectedTheme);
    this.themeIconURL = this.isHomePlayer
      ? this.homePlayerCurrentSelectedTheme.iconUrl
      : this.awayPlayerCurrentSelectedTheme.iconUrl;
    this.themeMultilanguageText = this.isHomePlayer
      ? this.homePlayerCurrentSelectedTheme.displayMultilanguageText
      : this.awayPlayerCurrentSelectedTheme.displayMultilanguageText;
    this.getCTAs();
  },
  methods: {
    ...mapMutations('game', [
      'setPlayersCurrentQuestionDTOs',
      'setPlayersHelpsUsedStatus',
    ]),
    getCTAs() {
      console.log(`Subscribing to channel: /topic/ctasFetched/${this.gameID}`);
      this.subscription = this.stompClient.subscribe(`/topic/ctasFetched/${this.gameID}`, (response) => {
        this.subscription.unsubscribe();
        console.log('[SelectedTheme] Inside ctasFetched response');
        // parse server response and return if any errors occur
        const responseBody = this.parseServerResponse(response.body);
        if (responseBody === null) {
          return;
        }
        const responseData = responseBody.gameDTO;
        console.log('responseData:', responseData);
        if (responseData.gameStateEnum === 'CTA_TO_BE_ANSWERED') {
          this.setPlayersCurrentQuestionDTOs({
            homePlayerQuestionDTO: responseData.homeUserDetails.questionDTO,
            awayPlayerQuestionDTO: responseData.awayUserDetails.questionDTO,
          });
          this.setPlayersHelpsUsedStatus({
            homePlayerCheatHelpUsed: responseData.homeUserDetails.cheatUsed,
            homePlayerFiftyFiftyHelpUsed: responseData.homeUserDetails.fiftyFiftyUsed,
            awayPlayerCheatHelpUsed: responseData.awayUserDetails.cheatUsed,
            awayPlayerFiftyFiftyHelpUsed: responseData.awayUserDetails.fiftyFiftyUsed,
          });
          this.normalTransition = true;
          console.log('going to game page');
          this.$router.replace('/game');
        }
      });
    },
  },
  computed: {
    ...mapState('game', [
      'gameID',
      'currentRoundNumber',
      'homePlayerCurrentSelectedTheme',
      'awayPlayerCurrentSelectedTheme',
    ]),
    ...mapGetters('game', [
      'isHomePlayer',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/SelectedTheme.vue